import { useMatch } from 'react-router';

function useDatasetParams() {
  const match = useMatch('/datasets/:id/:mode?');

  return match?.params;
}

export { useDatasetParams };
